import '@angular/compiler';
import { LayoutMainComponent } from './layout.main/layout.main.component';
import { PageRecommendComponent } from './page.recommend/page.recommend.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PageSearchComponent } from './page.search/page.search.component';
import { PageResultComponent } from './page.result/page.result.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PageAdminChartsComponent } from './page.admin.charts/page.admin.charts.component';
import { PageTestComponent } from './page.test/page.test.component';
import { PageAdminSongsComponent } from './page.admin.songs/page.admin.songs.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PageTestMeasureComponent } from './page.test.measure/page.test.measure.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PageHomeComponent } from './page.home/page.home.component';
import { PortalPostDetailComponent } from './portal.post.detail/portal.post.detail.component';
import { PagePracticeComponent } from './page.practice/page.practice.component';
import { LayoutAdminComponent } from './layout.admin/layout.admin.component';
import { PageFavoritesComponent } from './page.favorites/page.favorites.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PageSongDetailComponent } from './page.song.detail/page.song.detail.component';
import { PortalPostListComponent } from './portal.post.list/portal.post.list.component';

const INDEX_PAGE = "";

import { URLPattern } from "urlpattern-polyfill";
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

let app_routes: any[] = [
    {
        component: LayoutMainComponent,
        "children": [
            {
                "path": "recommend",
                component: PageRecommendComponent,
                "app_id": "page.recommend"
            },
            {
                "path": "search",
                component: PageSearchComponent,
                "app_id": "page.search"
            },
            {
                "path": "result/:id",
                component: PageResultComponent,
                "app_id": "page.result"
            },
            {
                "path": "test",
                component: PageTestComponent,
                "app_id": "page.test"
            },
            {
                "path": "test/measure",
                component: PageTestMeasureComponent,
                "app_id": "page.test.measure"
            },
            {
                "path": "",
                component: PageHomeComponent,
                "app_id": "page.home"
            },
            {
                "path": "practice",
                component: PagePracticeComponent,
                "app_id": "page.practice"
            },
            {
                "path": "favorites",
                component: PageFavoritesComponent,
                "app_id": "page.favorites"
            },
            {
                "path": "song/:id",
                component: PageSongDetailComponent,
                "app_id": "page.song.detail"
            }
        ]
    },
    {
        component: LayoutAdminComponent,
        "children": [
            {
                "path": "admin/charts",
                component: PageAdminChartsComponent,
                "app_id": "page.admin.charts"
            },
            {
                "path": "admin/songs",
                component: PageAdminSongsComponent,
                "app_id": "page.admin.songs"
            }
        ]
    }
];

// 빈 경로("") 자식을 포함한 레이아웃(홈 레이아웃)을 먼저 처리해야
// Angular Router가 "/" URL에서 admin 레이아웃을 먼저 선택하는 문제를 방지한다.
app_routes.sort((a: any, b: any) => {
    const aHasEmpty = a.children && a.children.some((c: any) => c.path === '');
    const bHasEmpty = b.children && b.children.some((c: any) => c.path === '');
    if (aHasEmpty && !bHasEmpty) return -1;
    if (!aHasEmpty && bHasEmpty) return 1;
    return 0;
});

export class RouteInfo {
    public path: any = "";
    public segment: any = {};

    constructor() { }
}

(window as any).WizRoute = new RouteInfo();

let patternMatcher = (pattern: any, url: any) => {
    let urlpath = url.map((x: any) => x.path).join("/");
    let testurl = 'http://test/';
    pattern = '/' + pattern;
    urlpath = testurl + urlpath;
    pattern = new URLPattern({ pathname: pattern });
    pattern = pattern.exec(urlpath)
    if (pattern && pattern.pathname) {
        let posParams: any = {};
        for (let key in pattern.pathname.groups) {
            if (pattern.pathname.groups[key]) {
                posParams[key] = pattern.pathname.groups[key];
            }
        }
        (window as any).WizRoute.path = url.map((x: any) => x.path).join("/");
        (window as any).WizRoute.segment = posParams;

        return { consumed: url, posParams: posParams };
    }
    return null
}

let routes: Routes = [{
    matcher: (url: any) => {
        for (let i = 0; i < app_routes.length; i++) {
            let layout = app_routes[i];
            let layout_childs = layout.children || [];
            for (let j = 0; j < layout_childs.length; j++) {
                let child = layout_childs[j];
                let matcher = patternMatcher(child.path, url);
                if (matcher)
                    return null;
            }
        }
        return { consumed: url, posParams: {} };
    },
    redirectTo: INDEX_PAGE
}];

for (let i = 0; i < app_routes.length; i++) {
    let layout = app_routes[i];
    let layout_component = layout.component;
    let layout_childs = layout.children || [];

    let router: any = {
        path: '',
        component: layout_component,
        children: []
    };

    for (let j = 0; j < layout_childs.length; j++) {
        let child = layout_childs[j];
        router.children.push({
            matcher: (url: any) => {
                let matcher = patternMatcher(child.path, url);
                if (matcher) return matcher;
                return null;
            },
            component: child.component
        });
    }
    routes.push(router);
}

@NgModule({ imports: [RouterModule.forRoot(routes)], exports: [RouterModule] })
export class AppRoutingModule { }
